import { render, staticRenderFns } from "./quesGuide2_1.vue?vue&type=template&id=3bc7114e"
import script from "./quesGuide2_1.vue?vue&type=script&lang=js"
export * from "./quesGuide2_1.vue?vue&type=script&lang=js"
import style0 from "./quesGuide2_1.vue?vue&type=style&index=0&id=3bc7114e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports